import {mapValues} from 'lodash';
// eslint-disable-next-line no-restricted-imports
import {
  createStructuredSelector as reselectCreateStructuredSelector,
  ParametricSelector,
  Selector,
} from 'reselect';

import {KnowledgeBaseState} from './knowledgeBaseAppState';
import {KnowledgeBaseThunkAction, KnowledgeBaseThunkDispatch} from './knowledgeBaseAppThunk';

export type KnowledgeBaseSelector<T> = Selector<KnowledgeBaseState, T>;
export type KnowledgeBaseParametricSelector<P, T> = ParametricSelector<KnowledgeBaseState, P, T>;

/** Saner MapStateToProps + CreateStructureSelector. */
export function makeMapStateToProps<P = {}>() {
  return function mstpMaker<T>(
    makeSelectors: () => {[K in keyof T]: KnowledgeBaseParametricSelector<P, T[K]>},
  ) {
    return () => reselectCreateStructuredSelector(makeSelectors());
  };
}

type AnonymousFunction = (...args: any) => any;
type UnwrappedThunkAction<T> = T extends KnowledgeBaseThunkAction<infer R> ? R : T;
export type UnwrappedActionCreator<T extends AnonymousFunction> = (
  ...args: Parameters<T>
) => UnwrappedThunkAction<ReturnType<T>>;

export function makeMapDispatchToProps<P = {}>() {
  return function mdtpMaker<T extends {[K: string]: AnonymousFunction}>(makeActionCreators: (props: P) => T) {
    return (
      dispatch: KnowledgeBaseThunkDispatch,
      props: P,
    ): {[K in keyof T]: UnwrappedActionCreator<T[K]>} => {
      const actionCreators = makeActionCreators(props);
      return mapValues(
        actionCreators,
        (value) =>
          (...args: any[]) =>
            dispatch(value(...args)),
      );
    };
  };
}
